module.exports = __webpack_public_path__ + "img/auto-infographie.0926c502.png";